<template>
  <span v-if="isShowItem" class="c-line-form-item__show"/>
  <c-select
    v-else-if="type === 'select'"
    ref="input"
    :value="value || defaultValue"
    v-bind="data"
    @on-input="onInput"
  />
  <c-textarea
    v-else-if="type === 'textarea'"
    ref="input"
    :value="value || defaultValue"
    v-bind="data"
    @on-input="onInput"
  />
  <c-input
    v-else
    ref="input"
    :value="value || defaultValue"
    v-bind="data"
    @on-input="onInput"
  />
</template>

<script>
import CInput from './CInput'
import CSelect from './CSelect'
import CTextarea from './CTextarea'
import { computed, ref } from 'vue'

export default {
  name: 'CLineFormItem',
  components: {
    CInput,
    CSelect,
    CTextarea
  },
  emits: ['on-input'],
  props: {
    // Values
    type: String,
    defaultValue: undefined,
    value: undefined,
    data: undefined,

    isShow: undefined,
    inputsValue: undefined
  },
  setup (props, context) {
    return {
      input: ref(undefined),
      onInput: event => context.emit('on-input', event),

      isShowItem: computed(() => !(!props.isShow || props.isShow(props.inputsValue)))
    }
  }
}
</script>

<style lang="scss">
.c-line-form-item__show {
  display: none;
}
</style>
